import React, { useCallback, useState } from "react";
//#region redux
//#endregion
//#region types
import { FieldConstants } from "utils/constants";
//#endregion
//#region components
import { useDebouncedCallback } from "use-debounce";
//#endregion

interface useDebounceInputProps {
  name: string;
  value: any;
  handleOnChangeCustom?: (name: string, data: any) => void;
  noDebounce?: boolean;
}

function useDebounceInput(props: useDebounceInputProps) {
  const [internalValue, setInternalValue] = useState(props.value);
  const [name, setName] = useState(props.name);

  React.useEffect(() => {
    if (props.value !== internalValue) setInternalValue(props.value);
  }, [props.value]);

  React.useEffect(() => {
    setName(props.name);
  }, [props.name]);

  const debouncedHandleOnChange = useDebouncedCallback(
    (name: string, data: any) => {
      props.handleOnChangeCustom && props.handleOnChangeCustom(name, data);
    },
    props.noDebounce ? 0 : FieldConstants.DebounceTime
  );

  const handleOnChange = useCallback(
    (e: React.ChangeEvent<any>) => {
      e.persist();
      const target = e.target;
      const newValue = (target.type === "checkbox" ? target.checked : target.value) ?? undefined;
      setInternalValue(newValue);
      debouncedHandleOnChange(name, newValue);
    },
    [name]
  );

  const handleOnChangeCustom = useCallback((name: string, data: any) => {
    setInternalValue(data ?? undefined);
    debouncedHandleOnChange(name, data ?? undefined);
  }, []);

  return {
    internalValue: internalValue,
    debouncedHandleOnChange: handleOnChange,
    debouncedHandleOnChangeCustom: handleOnChangeCustom,
  };
}

export default useDebounceInput;
